<div class="size-4">
  <app-svg-icon
    [icon]="icon()"
    fill="#F5F5F5" />
</div>
